import React from "react";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import { IoMdCloseCircle } from "react-icons/io";
import { State, City } from "country-state-city";
import Select from "react-select";

const EditPg = ({ setEditLoadModal, currentItem }) => {
  const [floorOptions, setFloorOptions] = useState(currentItem.totalFloors);
  const [floorRoomsList, setFloorRoomsList] = useState([
    ...currentItem.floorDetails,
  ]);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [currentData, setCurrentData] = useState({ ...currentItem });
  const [calculatedTotalRooms, setCalculatedTotalRooms] = useState(0);
  const [rentAgreement, setRentAgreement] = useState([]);
  const [images, setImages] = useState([]);

  const [load, setLoad] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();

  console.log("----->", currentItem);

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nameBuilding: currentItem.nameBuilding || "",
      buildingType: currentItem.buildingType || "",
      pgType: currentItem.pgType || "",
      pgAddress: currentItem.pgAddress || "",
      city: currentItem.city || "",
      state: currentItem.state || "",
      pincode: currentItem.pincode || "",
      ownerName: currentItem.ownerName || "",
      ownerPhoneNo: currentItem.ownerPhoneNo || "",
      totalFloors: currentItem.totalFloors || "",
      totalRooms: currentItem.totalRooms || "",
      startingPrice: currentItem.startingPrice || "",
      mapLink: currentItem.mapLink,
      overview: currentItem.overview,
      amenities: {
        airConditioner: currentItem.amenities?.airConditioner || false,
        internet: currentItem.amenities?.internet || false,
        washingMachine: currentItem.amenities?.washingMachine || false,
        refrigerator: currentItem.amenities?.refrigerator || false,
        furnishedRooms: currentItem.amenities?.furnishedRooms || false,
        commonLoungeArea: currentItem.amenities?.commonLoungeArea || false,
        bikeParking: currentItem.amenities?.bikeParking || false,
        carParking: currentItem.amenities?.carParking || false,
      },
      floorDetails: currentItem.floorDetails || [
        { floorNumber: "", numberOfRooms: "" },
      ],
      rentAgreement: rentAgreement,
      images: images,
    },
  });

  console.log("Images: ", images);

  // Define amenities list here
  const amenitiesList = [
    "airConditioner",
    "internet",
    "washingMachine",
    "refrigerator",
    "furnishedRooms",
    "commonLoungeArea",
    "bikeParking",
    "carParking",
  ];

  //Fetching all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  //Setting existing state to the selectedState initially
  useEffect(() => {
    if (allStates.length > 0 && currentItem?.state) {
      const selectedState = allStates.find(
        (state) => state.label === currentItem?.state
      );
      setSelectedState(selectedState || null);
    }
  }, [allStates, currentItem]);

  console.log("Preloaded State: ", selectedState);

  //Fetch cities when a state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  console.log("Citis: ", allCities);

  const onSubmit = (data) => {
    setLoad(true);
    const myData = {
      ...data,
      floorDetails: floorRoomsList,
      totalRooms: calculatedTotalRooms,
      rentAgreement: rentAgreement,
      images: images,
    };
    console.log("I am running----->", myData);

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/update_building/${currentItem._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setEditLoadModal(false);
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setLoad(false);
      });
  };

  const totalFloors = watch("totalFloors");

  useEffect(() => {
    setRentAgreement(currentItem?.rentAgreement);
    setImages(currentItem?.images);
  }, []);

  console.log("Rent Agreement: ", rentAgreement);

  const handleRentAgreementChange = async (file) => {
    const files = Array.from(file);

    const newFiles = await Promise.all(
      files.map(async (file) => {
        return await uploadImg(file);
      })
    );
    console.log("New files: ", newFiles);

    setRentAgreement((prevData) => [...prevData, ...newFiles]);
  };

  const handleImageChange = async (file) => {
    const files = Array.from(file);

    const newFiles = await Promise.all(
      files.map(async (file) => {
        return await uploadImg(file);
      })
    );
    console.log("New files: ", newFiles);

    setImages((prevData) => [...prevData, ...newFiles]);
  };

  // const handleImageChange = async (fileList) => {
  //   const files = Array.from(fileList);

  //   const newFiles = await Promise.all(
  //     files.map(async (file) => {
  //       // Upload and get the URL (or use local preview)
  //       return await uploadImg(file);
  //     })
  //   );

  //   setImages((prevImages) => [...prevImages, ...newFiles]);
  // };

  // const handleRemoveImage = (indexToRemove) => {
  //   setImages((prevImages) =>
  //     prevImages.filter((_, index) => index !== indexToRemove)
  //   );
  // };

  // const handleImageChange = async (fileList) => {
  //   const files = Array.from(fileList);

  //   const newFiles = await Promise.all(
  //     files.map(async (file) => {
  //       return await uploadImg(file); // returns URL
  //     })
  //   );

  //   const updatedImages = [...images, ...newFiles];

  //   setImages(updatedImages);
  //   setValue("images", updatedImages, { shouldValidate: true }); // ✅ Sync with form state
  // };

  const removeRentAgreement = (indexToRemove) => {
    setRentAgreement((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const removeImage = (indexToRemove) => {
    setImages((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  useEffect(() => {
    if (totalFloors) {
      const floorCount = parseInt(totalFloors, 10);
      setFloorOptions(Array.from({ length: floorCount }, (_, i) => i + 1));
    } else {
      setFloorOptions([]);
    }
  }, [totalFloors]);

  useEffect(() => {
    const total = floorRoomsList.reduce(
      (acc, floor) => acc + parseInt(floor.numberOfRooms, 10),
      0
    );
    setCalculatedTotalRooms(total);
  }, [floorRoomsList]);

  const handleAddFloorRooms = () => {
    if (selectedFloor && numberOfRooms) {
      setFloorRoomsList((prevList) => [
        ...prevList,
        { floorNumber: selectedFloor, numberOfRooms },
      ]);
      setSelectedFloor("");
      setNumberOfRooms("");
    }
  };

  const handleRemoveFloorRooms = (floorNumber) => {
    setFloorRoomsList((prevList) =>
      prevList.filter((item) => item.floorNumber !== floorNumber)
    );
  };

  // Determine which options are selectable based on the sequential requirement
  const nextSelectableFloor =
    floorRoomsList.length > 0
      ? floorRoomsList[floorRoomsList.length - 1].floorNumber + 1
      : 1;

  useEffect(() => {
    reset({
      nameBuilding: currentItem.nameBuilding || "",
      buildingType: currentItem.buildingType || "",
      pgType: currentItem.pgType || "",
      pgAddress: currentItem.pgAddress || "",
      city: currentItem.city || "",
      state: currentItem.state || "",
      pincode: currentItem.pincode || "",
      ownerName: currentItem.ownerName || "",
      ownerPhoneNo: currentItem.ownerPhoneNo || "",
      totalFloors: currentItem.totalFloors || "",
      totalRooms: currentItem.totalRooms || "",
      // totalBeds: currentItem.totalBeds || "",
      rentAgreement: currentItem.rentAgreement || [],
      amenities: {
        food: currentItem.amenities?.food || false,
        internet: currentItem.amenities?.internet || false,
        washingMachine: currentItem.amenities?.washingMachine || false,
        refrigerator: currentItem.amenities?.refrigerator || false,
        gym: currentItem.amenities?.gym || false,
        bikeParking: currentItem.amenities?.bikeParking || false,
        carParking: currentItem.amenities?.carParking || false,
      },
      floorDetails: currentItem.floorDetails || [
        { floorNumber: "", numberOfRooms: "" },
      ],
    });
  }, []);

  return (
    <div className=" bg-[black]/10  fixed inset-0 w-full z-50 flex justify-center items-center backdrop-blur-sm  ">
      <div className="p-8 lg:py-8 lg:px-16 relative overflow-auto h-[25rem] lg:h-[35rem] bg-white shadow-lg rounded-lg w-full max-w-5xl ">
        <h2 className="text-2xl font-semibold text-center mb-6">Edit PG</h2>
        <AiFillCloseCircle
          onClick={() => {
            setEditLoadModal(false);
          }}
          className="cursor-pointer text-primaryColor absolute top-4 right-4 "
          size={30}
        />
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Name Of Building *
              </label>
              <input
                type="text"
                {...register("nameBuilding")}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.nameBuilding ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Building Type *
              </label>
              <select
                {...register("buildingType", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.buildingType ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select Type</option>
                <option value="Apartment">Apartment</option>
                <option value="Hostel">Hostel</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                PG Type *
              </label>
              <select
                {...register("pgType", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pgType ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select PG Type</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Address *
              </label>
              <input
                type="text"
                {...register("pgAddress", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pgAddress ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            {/* State */}
            <div>
              <label
                htmlFor="state"
                className="text-sm font-medium text-primaryTextColor"
              >
                State *
              </label>

              <Select
                options={allStates}
                value={
                  allStates.find((state) => state.label === watch("state")) ||
                  null
                } // Pre-select state in edit mode
                onChange={(option) => {
                  console.log("option", option);
                  setSelectedState(option);
                  setValue("state", option.label, { shouldValidate: true }); // Ensure validation triggers
                }}
                required
                placeholder="Select State"
                className={`border ${
                  errors.state ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.state && (
                <span className="text-red-500 text-sm">
                  {errors.state.message}
                </span>
              )}
            </div>

            {/* City */}
            <div>
              <label
                htmlFor="city"
                className="text-sm font-medium text-primaryTextColor"
              >
                City *
              </label>

              <Select
                options={allCities}
                value={
                  allCities.find((city) => city.label === watch("city")) || null
                } // Pre-select state in edit mode
                onChange={(option) => {
                  console.log("option", option);
                  setValue("city", option.label, { shouldValidate: true }); // Ensure validation triggers
                }}
                required
                placeholder="Select City"
                className={`border ${
                  errors.city ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  {errors.city.message}
                </span>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Pin Code *
              </label>
              <input
                type="text"
                {...register("pincode", {
                  required: "PIN Code is required",
                  pattern: {
                    value: /^[1-9][0-9]{5}$/,
                    message: "Invalid PIN Code",
                  },
                })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.pincode ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 6);
                }}
              />
              {errors.pincode && (
                <span className="text-red-500 text-sm">
                  {errors.pincode.message}
                </span>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Owner's Name *
              </label>
              <input
                type="text"
                {...register("ownerName", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.ownerName ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Owner's Contact No. *
              </label>
              <input
                type="text"
                {...register("ownerPhoneNo", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.ownerPhoneNo ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
            </div>

            {/* Rent Agreement  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Rent Agreement
              </label>

              <input
                type="file"
                id="rentAgreement"
                accept="image/*"
                {...register("rentAgreement")}
                onChange={(e) => {
                  handleRentAgreementChange(e.target.files);
                }}
                multiple
                className={`mt-1 p-2 border ${
                  errors.rentAgreement ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />

              <div className="flex flex-wrap gap-2">
                {rentAgreement?.map((image, index) => (
                  <div key={index} className="relative p-1">
                    <IoMdCloseCircle
                      className="absolute top-1 -right-1 cursor-pointer font-bold"
                      color="red"
                      size={16}
                      onClick={() => removeRentAgreement(index)}
                    />

                    <img
                      src={image}
                      alt=""
                      className="w-[6rem] rounded-md object-cover mt-2"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Images  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Images
              </label>
              <input
                type="file"
                id="images"
                accept="image/*"
                {...register("images")}
                onChange={(e) => handleImageChange(e.target.files)}
                multiple
                className={`mt-1 p-2 border ${
                  errors.images ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />

              {images.length > 0 && (
                <div className="flex flex-wrap gap-3 mt-3">
                  {images.map((image, index) => (
                    <div key={index} className="relative w-20 h-20">
                      {/* X icon */}
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        className="absolute top-0 right-0 bg-black bg-opacity-50 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-opacity-80"
                      >
                        &times;
                      </button>

                      <img
                        src={image}
                        alt={`img-${index}`}
                        className="w-full h-full object-cover rounded"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Starting Price  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Starting Price
              </label>
              <input
                type="text"
                {...register("startingPrice", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.startingPrice ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Map Link
              </label>
              <input
                type="text"
                {...register("mapLink", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.mapLink ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            {/* Overview  */}
            <div className="col-span-1 md:col-span-2">
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Overview
              </label>
              <textarea
                type="text"
                {...register("overview", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.overview ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>

            {/* Total Number Of Rooms  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Total Number of Rooms *
              </label>
              <input
                type="number"
                value={calculatedTotalRooms} // Display calculated total
                readOnly // Make it non-editable
                className={`w-full border p-2 rounded-lg focus:outline-none bg-gray-200 border-gray-300`}
              />
            </div>

            {/* Total Floors  */}
            <div>
              <label className="block text-sm font-medium text-primaryTextColor mb-1">
                Total Floors *
              </label>
              <input
                type="number"
                {...register("totalFloors", { required: true })}
                className={`w-full border p-2 rounded-lg focus:outline-none ${
                  errors.totalFloors ? "border-red-500" : "border-gray-300"
                }`}
                onInput={(e) => {
                  const newValue = e.target.value;

                  if (newValue === "") return; // Allow backspacing

                  if (Number(newValue) < currentItem?.totalFloors) {
                    toast.error("Number of floors can't be decreased");
                    e.target.value = currentItem.totalFloors; // Reset to previous value
                  }
                }}
              />
            </div>
          </div>

          {/* FLOOR SECTION */}
          {floorOptions.length > 0 && (
            <div className="grid grid-cols-2 gap-3 bg-gray-200 p-3 rounded-lg ">
              <div>
                <label className="block text-sm font-medium text-primaryTextColor mb-1">
                  Floor Number
                </label>
                <select
                  value={selectedFloor}
                  onChange={(e) => setSelectedFloor(parseInt(e.target.value))}
                  className="w-full border p-2 rounded-lg focus:outline-none"
                >
                  <option value="">Select Floor</option>
                  {floorOptions.map((floor) => (
                    <option
                      key={floor}
                      value={floor}
                      disabled={
                        floorRoomsList.some(
                          (item) => item.floorNumber === floor
                        ) || floor > nextSelectableFloor
                      }
                      style={{
                        color: floorRoomsList.some(
                          (item) => item.floorNumber === floor
                        )
                          ? "#00f700"
                          : "black",
                      }}
                    >
                      Floor {floor}
                    </option>
                  ))}
                </select>
              </div>

              {selectedFloor && (
                <div>
                  <label className="block text-sm font-medium text-primaryTextColor mb-1">
                    Number of Rooms
                  </label>
                  <input
                    type="number"
                    value={numberOfRooms}
                    max={50}
                    onChange={(e) =>
                      e.target.value <= 50
                        ? setNumberOfRooms(e.target.value)
                        : toast.error(
                            "Maximum 50 rooms can be added in a floor"
                          )
                    }
                    className="w-full border p-2 rounded-lg focus:outline-none"
                  />
                </div>
              )}
              {selectedFloor && (
                <button
                  type="button"
                  onClick={handleAddFloorRooms}
                  className="px-6 py-2 w-[6rem] float-right bg-primaryBtnColor text-white rounded-lg hover:via-primaryBtnHoverColor"
                >
                  Add
                </button>
              )}
            </div>
          )}
          {/* ----------------------- */}

          {/* Displaying the floor rooms list */}
          {floorRoomsList.length > 0 && (
            <div className="mt-4 p-3 bg-gray-200 rounded-lg">
              <h3 className="text-lg font-semibold mb-2">Floor Room Details</h3>
              <ul className="list-disc pl-5 space-y-1">
                {floorRoomsList.sort().map((item, index) => (
                  <li key={index} className="flex items-center space-x-4">
                    <span>
                      Floor {item.floorNumber}: {item.numberOfRooms} Rooms
                    </span>
                    <button
                      type="button"
                      onClick={() => handleRemoveFloorRooms(item.floorNumber)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-primaryTextColor mb-1">
              Choose Amenities
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {amenitiesList.map((amenity) => (
                <label
                  key={amenity}
                  className="flex items-center space-x-2 text-gray-600"
                >
                  <Controller
                    name={`amenities.${amenity}`}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        {...field}
                        checked={field.value} // Reflects current true/false values
                        className="rounded text-blue-500 focus:ring-blue-500"
                      />
                    )}
                  />
                  <span className="capitalize">
                    {amenity.replace(/([A-Z])/g, " $1")}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex justify-between items-center gap-6">
            <button
              onClick={() => {
                setEditLoadModal(false);
              }}
              type="button"
              className="px-6 py-2 border w-[50%] border-gray-400 text-primaryTextColor rounded-lg hover:bg-secondaryTextColor focus:outline-none"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-primaryBtnColor w-[50%] text-white rounded-lg hover:bg-primaryBtnHoverColor focus:outline-none"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>
      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default EditPg;
